import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  ModalFooter,
  Card,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import { AuthContext } from "../../../Auth/AuthContext";
import { useContext } from "react";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { FaPhoneAlt, FaGlobe } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { fetchCompanyProfile } from "../../../redux/recruiter/company_profile/actions";
import { fetchSkillsRequest } from "../../../redux/mandatorySkills/actions";
import { fetchRewardsPointsRequest } from "../../../redux/fetch_rewards_points/actions";
import {
  AVATAR,
  SYSTEM_PREFIX,
  roleOptions,
  customOptionsStyle,
} from "../../../Constant";
import Spinner from "../../Common/Spinner";
import { useParams } from "react-router";
import { FaGraduationCap } from "react-icons/fa6";
import { TbBuilding } from "react-icons/tb";
import {
  capitalize,
  formatWebsite,
  idToBase64,
} from "../../Common/CommonFunction";
import { IoIosArrowBack } from "react-icons/io";
import { showToast } from "../../Common/Toast";
import { IoIosArrowForward } from "react-icons/io";
import style1 from "./recruiterStyles/style1.css";
import style2 from "./recruiterStyles/style2.css";
import style3 from "./recruiterStyles/style3.css";
import style4 from "./recruiterStyles/style4.css";
import style5 from "./recruiterStyles/style5.css";
import style6 from "./recruiterStyles/style6.css";
import style7 from "./recruiterStyles/style7.css";
import style8 from "./recruiterStyles/style8.css";
import style9 from "./recruiterStyles/style9.css";
import style10 from "./recruiterStyles/style10.css";
import naukrify_poweredby from "../../../../src/assets/images/logo/naukrify_poweredby.png";
import {
  unlockLinkedInBannerRequest,
  resetUnlockLinkedInBannerMessage,
} from "../../../redux/unlock_linkedin_banner/actions";
import { getLinkedInBannerRequest } from "../../../redux/get_linkedin_banner/actions";
import { showStyledCoins } from "../../Common/CommonFunction";
const BannerScaleWrapper = ({ children, id }) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const parent = el.parentElement;
    if (!parent) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width || parent.getBoundingClientRect().width;
        if (width > 0) {
          setScale(Math.min(width / 1100, 1));
        }
      }
    });

    resizeObserver.observe(parent);

    const initialWidth = parent.getBoundingClientRect().width;
    if (initialWidth > 0) {
      setScale(Math.min(initialWidth / 1100, 1));
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      id={id}
      ref={containerRef}
      style={{
        zoom: scale,
        width: "1100px",
        position: "relative",
      }}
    >
      {children}
    </div>
  );
};

const BannerModal = (props) => {
  const dispatch = useDispatch();
  const savedState = localStorage.getItem("bannerProfile");
  const parsedState = JSON.parse(savedState);
  const [errors, setErrors] = useState({});
  const [currentIndex, setCurrentIndex] = useState(props.index);
  const componentRef = useRef(null);
  const { triggerTotalPoints } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false); // Step 1: Add loading state
  const [isBannerUnlocked, setIsBannerUnlocked] = useState(false);

  const [profile, setProfile] = useState({
    photo: AVATAR,
    name: "",
    email: "",
    phone: "",
    role: null,

    includeEmail: false,
    includePhone: false,
    includeWebsite: false,
    quotes: parsedState && parsedState.quotes ? parsedState.quotes : "",
    jobs: parsedState && parsedState.jobs ? parsedState.jobs : "",

    company_name: "",
    company_logo: null,
    company_website: null,
  });

  const getLinkedinBannerReducerData = useSelector(
    (state) => state.getLinkedinBannerReducer
  );
  const allBanners = getLinkedinBannerReducerData.data;

  const recruiterProfileReducerData = useSelector(
    (state) => state.recruiterProfileReducer
  );

  // Effect to update isBannerUnlocked when currentIndex changes
  useEffect(() => {
    if (allBanners[currentIndex]) {
      setIsBannerUnlocked(allBanners[currentIndex].is_purchased);
    }
  }, [currentIndex, allBanners]);

  useEffect(() => {
    if (
      !recruiterProfileReducerData.isLoading &&
      recruiterProfileReducerData.data &&
      recruiterProfileReducerData.status === true
    ) {
      const data = recruiterProfileReducerData.data;

      if (savedState) {
        const updatedProfile = {
          photo: data.profile_image ? data.profile_image : AVATAR,
          name: data.recruiter_full_name,
          email: data.recruiter_email,
          phone: data.recruiter_mobile_number,
          role: roleOptions.find((option) => option.value === data.role)?.label,

          includeEmail: parsedState.includeEmail,
          includePhone: parsedState.includePhone,
          includeWebsite: parsedState.includeWebsite,
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      } else {
        const updatedProfile = {
          photo: data.profile_image ? data.profile_image : AVATAR,
          name: data.recruiter_full_name,
          email: data.recruiter_email,
          phone: data.recruiter_mobile_number,
          role: roleOptions.find((option) => option.value === data.role)?.label,

          includeEmail: !!data.recruiter_email,
          includePhone: !!data.recruiter_mobile_number,
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      }
    }
  }, [
    recruiterProfileReducerData.isLoading,
    recruiterProfileReducerData.data,
    recruiterProfileReducerData.status,
  ]);

  const companyProfileReducerData = useSelector(
    (state) => state.companyProfileReducer
  );

  useEffect(() => {
    dispatch(fetchCompanyProfile());
  }, [dispatch]);

  //const companyProfile = companyProfileReducerData.data;

  useEffect(() => {
    if (
      companyProfileReducerData &&
      companyProfileReducerData.data &&
      !companyProfileReducerData.isLoading
    ) {
      const data = companyProfileReducerData.data;

      if (savedState) {
        const updatedProfile = {
          includeWebsite: parsedState.includeWebsite,

          company_name: (data.company_name && data.company_name.label) || "",
          company_logo: data.company_logo || "",
          company_website: data.company_website || "",
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      } else {
        const updatedProfile = {
          includeWebsite: !!data.company_website,

          company_name: (data.company_name && data.company_name.label) || "",
          company_logo: data.company_logo || "",
          company_website: data.company_website || "",
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      }
    }
  }, [
    companyProfileReducerData.data,
    companyProfileReducerData.isLoading,
    currentIndex,
  ]);

  const jobsContainerRef = useRef(null);

  // const ensureFullOverflow = () => {
  //   const container = jobsContainerRef.current; // Get the container reference
  //   if (!container) {
  //     console.error("Container not found!");
  //     return;
  //   }
  //   const ulElement = container.querySelector("ul");
  //   const children = Array.from(ulElement.children); // Get the <li> elements
  //   // const children = Array.from(container.children);
  //   const containerHeight = container.clientHeight;

  //   let totalHeight = 0;
  //   let lastVisibleChildIndex = -1; // Track the last visible child index

  //   console.log(`Container height: ${containerHeight}`);

  //   // Reset all children styles to ensure we can measure their heights
  //   children.forEach((child) => {
  //     child.style.display = ""; // Reset display to ensure we can measure height
  //   });

  //   // Trigger reflow
  //   void container.offsetHeight;

  //   // Iterate over children to calculate visibility
  //   for (let i = 0; i < children.length; i++) {
  //     const child = children[i];
  //     console.log("childHeight", children[i], i);
  //     const childHeight = child.offsetHeight; // Get the height of the child
  //     totalHeight += childHeight;

  //     console.log(
  //       `Child ${i} height: ${childHeight}, Total: ${totalHeight}, containerHeight: ${containerHeight}`
  //     );

  //     if (totalHeight > containerHeight) {
  //       console.log(`Child ${i} causes overflow, hiding it.`);
  //       // Hide the child
  //       child.style.display = "none"; // Completely hide the child
  //       // child.style.color = "red";
  //     } else {
  //       lastVisibleChildIndex = i; // Update the last visible index
  //     }
  //   }

  //   console.log(`Last visible child index: ${lastVisibleChildIndex}`);

  //   // Restore visible children to full visibility
  //   for (let i = 0; i <= lastVisibleChildIndex; i++) {
  //     const child = children[i];
  //     child.style.display = ""; // Reset display to show the child
  //   }

  //   // If no children are visible, ensure at least one is shown
  //   if (lastVisibleChildIndex === -1 && children.length > 0) {
  //     const firstChild = children[0];
  //     firstChild.style.display = ""; // Show the first child
  //   }
  // };

  const ensureFullOverflow = () => {
    const container = jobsContainerRef.current; // Get the container reference
    if (!container) {
      console.error("Container not found!");
      return;
    }
    const ulElement = container.querySelector("ul");
    const children = Array.from(ulElement.children); // Get the <li> elements
    const containerWidth = container.clientWidth; // Get the container width
    const containerHeight = container.clientHeight; // Get the container height

    let totalWidth = 0;
    let totalHeight = 0;
    let lastVisibleChildIndex = -1; // Track the last visible child index

    console.log(
      `Container width: ${containerWidth}, height: ${containerHeight}`
    );

    // Reset all children styles to ensure we can measure their dimensions
    children.forEach((child) => {
      child.style.display = ""; // Reset display to ensure we can measure width and height
    });

    // Trigger reflow
    void container.offsetWidth;

    // Iterate over children to calculate visibility
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const childWidth = child.offsetWidth; // Get the width of the child
      const childHeight = child.offsetHeight; // Get the height of the child

      // Add margin-bottom of 5px to the total height
      const marginBottom = 5;
      totalWidth += childWidth;
      totalHeight += childHeight + marginBottom; // Include margin in total height

      console.log(
        `Child ${i} width: ${childWidth}, height: ${childHeight}, Total Width: ${totalWidth}, Total Height: ${totalHeight}, Container Width: ${containerWidth}, Container Height: ${containerHeight}`
      );

      // Check for horizontal overflow
      if (totalWidth > containerWidth) {
        console.log(`Child ${i} causes horizontal overflow, hiding it.`);
        child.style.display = "none"; // Hide the child
      } else {
        lastVisibleChildIndex = i; // Update the last visible index
      }

      // Check for vertical overflow
      if (totalHeight > containerHeight) {
        console.log(`Child ${i} causes vertical overflow, hiding it.`);
        child.style.display = "none"; // Hide the child
      } else {
        lastVisibleChildIndex = i; // Update the last visible index
      }
    }

    console.log(`Last visible child index: ${lastVisibleChildIndex}`);

    // Restore visible children to full visibility
    for (let i = 0; i <= lastVisibleChildIndex; i++) {
      const child = children[i];
      child.style.display = ""; // Reset display to show the child
    }

    // If no children are visible, ensure at least one is shown
    if (lastVisibleChildIndex === -1 && children.length > 0) {
      const firstChild = children[0];
      firstChild.style.display = ""; // Show the first child
    }
  };

  // Call on load and resize
  useEffect(() => {
    // Use setTimeout to ensure the DOM is fully rendered
    const timeoutId = setTimeout(() => {
      ensureFullOverflow(); // Initial call to set visibility
    }, 0);

    window.addEventListener("resize", ensureFullOverflow);

    // Cleanup event listeners on unmount
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", ensureFullOverflow);
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    setErrors({ ...errors, [name]: error });

    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));

    // Call ensureFullOverflow after updating the profile
    // ensureFullOverflow();
  };

  // Use useEffect to call ensureFullOverflow when profile changes
  useEffect(() => {
    ensureFullOverflow();
  }, [profile]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: checked,
    }));
  };

  const handleNext = (event) => {
    event.preventDefault(); // Prevents the default form or link behavior
    setCurrentIndex((prevIndex) => (prevIndex + 1) % allBanners.length);
  };

  const handlePrevious = (event) => {
    event.preventDefault(); // Prevents the default form or link behavior
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + allBanners.length) % allBanners.length
    );
  };

  useEffect(() => {
    // Update the quotes when the slide (currentIndex) changes
    if (!profile.quotes) {
      setProfile((prevProfile) => ({
        ...prevProfile,
        quotes: allBanners[currentIndex].default_quotes || "", // Set the quotes from the banner or an empty string if not available
      }));
    }
  }, [currentIndex, allBanners]);

  const validate = () => {
    const errors = {};
    let isValid = true;

    // if (allBanners[currentIndex].job_allowed != 0) {
    //   const jobTitles = profile.jobs.split(",").map((job) => job.trim());
    //   if (jobTitles.length > allBanners[currentIndex].job_allowed) {
    //     errors.jobs = `You can only enter up to ${allBanners[currentIndex].job_allowed} jobs.`;
    //     isValid = false;
    //   }
    // }
    setErrors(errors);
    return isValid;
  };

  useEffect(() => {
    localStorage.setItem(
      "bannerProfile",
      JSON.stringify({
        includeName: profile.includeName,
        includeEmail: profile.includeEmail,
        includePhone: profile.includePhone,
        includeWebsite: profile.includeWebsite,

        jobs: profile.jobs,
        quotes: profile.quotes,
      })
    );
  }, [profile]);

  const [isDownloading, setIsDownloading] = useState(false); // State to track if download is in progress

  const componentPreRef = useRef(null);
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const getApiImageUrl = () => {
    const fullUrl = allBanners[currentIndex].banner_template_image;

    // extract filename
    const fileName = fullUrl.split("/").pop();

    // return `https://api.indiagethired.com/linkedin_banner_image?p=uploads/linkedin_banner/${fileName}`;
    return `https://api-test.xyntara.in/linkedin_banner_image?p=uploads/linkedin_banner/${fileName}`;
  };

  // const handleDownloadClick = async () => {
  //   console.log("errors", errors);
  //   if (validate()) {
  //     // Save the current profile state to local storage
  //     // localStorage.setItem(
  //     //   "bannerProfile",
  //     //   JSON.stringify({
  //     //     includeName: profile.includeName,
  //     //     includeEmail: profile.includeEmail,
  //     //     includePhone: profile.includePhone,
  //     //     includeWebsite: profile.includeWebsite,

  //     //     jobs: profile.jobs,
  //     //     quotes: profile.quotes,
  //     //   })
  //     // );

  //     if (prevButtonRef.current) {
  //       prevButtonRef.current.style.display = "none";
  //     }
  //     if (nextButtonRef.current) {
  //       nextButtonRef.current.style.display = "none";
  //     }

  //     setIsDownloading(true); // Disable the download button

  //     // const sliderControls = document.querySelector(".slider-controls");
  //     try {
  //       // Temporarily hide the .slider-controls div
  //       // if (sliderControls) {
  //       //   sliderControls.style.display = "none";
  //       // }

  //       const canvas = await html2canvas(componentRef.current, {
  //         allowTaint: true,
  //         useCORS: true,
  //         scale: 2,
  //       });
  //       const imgData = canvas.toDataURL("image/png");
  //       const blob = dataURItoBlob(imgData);

  //       const file_name = profile.name
  //         ? SYSTEM_PREFIX + profile.name + ".png"
  //         : SYSTEM_PREFIX + "_linked_banner.png";
  //       saveAs(blob, file_name);
  //     } catch (error) {
  //       console.error("Error capturing element:", error);
  //     } finally {
  //       // Show the .slider-controls div again
  //       if (prevButtonRef.current) {
  //         prevButtonRef.current.style.display = "block";
  //       }
  //       if (nextButtonRef.current) {
  //         nextButtonRef.current.style.display = "block";
  //       }
  //       setIsDownloading(false); // Re-enable the download button
  //     }
  //   }
  // };

  const handleDownloadClick = async () => {
    if (validate()) {
      if (prevButtonRef.current) prevButtonRef.current.style.display = "none";
      if (nextButtonRef.current) nextButtonRef.current.style.display = "none";

      setIsDownloading(true);

      const scaleWrapper = document.getElementById("recruiter-banner-scale-wrapper");
      const originalZoom = scaleWrapper ? scaleWrapper.style.zoom : "";

      const bannerDiv = componentRef.current;
      const profileImgElement = bannerDiv ? bannerDiv.querySelector(".profile-img") : null;
      const originalProfileImgDisplay = profileImgElement ? profileImgElement.style.display : "";

      try {
        if (profileImgElement) {
          profileImgElement.style.display = "none";
        }

        if (scaleWrapper) {
          scaleWrapper.style.zoom = "1";
        }

        const originalBg = bannerDiv ? bannerDiv.style.backgroundImage : "";
        const apiUrl = getApiImageUrl();

        if (bannerDiv) {
          bannerDiv.style.backgroundImage = `url(${apiUrl})`;
          await new Promise((resolve) => {
            const img = new Image();
            img.src = apiUrl;
            if (img.complete && img.naturalWidth !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          });
        }

        // 🔥 Capture with html2canvas
        const canvas = await html2canvas(componentRef.current, {
          allowTaint: true,
          useCORS: true,
          scale: 2,
          width: 1100,
          height: 273,
          windowWidth: 1100,
          windowHeight: 273,
          scrollX: 0,
          scrollY: 0,
          ignoreElements: (element) => {
            return (
              element.classList && element.classList.contains("profile-img")
            );
          },
        });

        const imgData = canvas.toDataURL("image/png");
        const blob = dataURItoBlob(imgData);

        const file_name = profile.name
          ? SYSTEM_PREFIX + profile.name + ".png"
          : SYSTEM_PREFIX + "_linked_banner.png";

        saveAs(blob, file_name);

        if (bannerDiv && originalBg) {
          bannerDiv.style.backgroundImage = originalBg;
        }

      } catch (error) {
        console.error("Error capturing element:", error);
      } finally {
        if (profileImgElement) {
          profileImgElement.style.display = originalProfileImgDisplay;
        }
        if (scaleWrapper) {
          scaleWrapper.style.zoom = originalZoom;
        }
        if (prevButtonRef.current) prevButtonRef.current.style.display = "block";
        if (nextButtonRef.current) nextButtonRef.current.style.display = "block";
        setIsDownloading(false);
      }
    }
  };
  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: "image/png" });
  };

  const handlePurchaseClick = () => {
    setIsLoading(true); // Step 2: Set loading state to true
    // Dispatch the action to unlock the banner

    dispatch(
      unlockLinkedInBannerRequest({
        banner_id: idToBase64(allBanners[currentIndex].banner_id),
      })
    );

    // Update the local state to reflect that the banner is purchased
    // setIsBannerUnlocked(true);
    allBanners[currentIndex].is_purchased = true;

    console.log("Purchase button clicked, unlocking banner");
    // You can add any additional logic here, such as showing a success message
  };

  const unlockLinkedinBannerReducerData = useSelector(
    (state) => state.unlockLinkedinBannerReducer
  );

  useEffect(() => {
    if (
      unlockLinkedinBannerReducerData.status == true &&
      unlockLinkedinBannerReducerData.message != ""
    ) {
      showToast("success", unlockLinkedinBannerReducerData.message);

      triggerTotalPoints("buy_banner", false);

      setIsBannerUnlocked(true);
      setIsLoading(false);
      allBanners[currentIndex].is_purchased = true;
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockLinkedInBannerMessage());

      // setIsPurchased(true);
      // setSelectedType("FREE");
    } else if (
      unlockLinkedinBannerReducerData.status == false &&
      unlockLinkedinBannerReducerData.message != ""
    ) {
      // setIsPurchased(false);
      setIsLoading(false);
      showToast("error", unlockLinkedinBannerReducerData.message);
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockLinkedInBannerMessage());
    }
  }, [unlockLinkedinBannerReducerData]);

  const fetchRewardsPointsReducerData = useSelector(
    (state) => state.fetchRewardsPointsReducer
  );

  useEffect(() => {
    if (
      !fetchRewardsPointsReducerData ||
      !fetchRewardsPointsReducerData.data ||
      !Array.isArray(fetchRewardsPointsReducerData.data) ||
      fetchRewardsPointsReducerData.data.length <= 0
    ) {
      dispatch(fetchRewardsPointsRequest());
    }
  }, []);
  const buyResumePoints =
    fetchRewardsPointsReducerData?.data?.find(
      (item) => item.name === "buy_banner"
    )?.points ?? 0;

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-xl linkedin-banner-modal"
      backdrop="static"
      fade={false}
    >
      <Form className="theme-form">
        <ModalHeader className="border-0" toggle={props.toggleModal}>
          AI LinkedIn Banner
        </ModalHeader>
        <ModalBody className="p-4">
          {getLinkedinBannerReducerData.isLoading ? (
            <Spinner />
          ) : (
            <div className="linked-banner-main">
              <div className="banner-div">
                <BannerScaleWrapper id="recruiter-banner-scale-wrapper">
                  <div style={{ position: "relative" }}>
                    {isBannerUnlocked !== true && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "1100px",
                          height: "273px",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 10,
                          borderRadius: "4px",
                        }}
                      >
                        <Card
                          className="mt-2"
                          style={{ width: "380px" }}
                        >
                          <CardBody className="d-flex flex-column align-items-center">
                            <div
                              className="mb-3 mb-md-0 text-center"
                              style={{
                                width: "100%",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                            >
                              <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                                  Unlock this premium banner
                                  {/* by using{" "}
                                {showStyledCoins(allBanners[currentIndex].price)} ! */}
                              </h6>
                            </div>
                            <div className="mt-2">
                              <Button color="warning" onClick={handlePurchaseClick}>
                                {isLoading ? "Unlocking..." : "UNLOCK"}
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    )}
                    <div
                      className={`banner-${allBanners[currentIndex].banner_id}`}
                      ref={componentRef}
                      style={{
                        backgroundImage: `url(${allBanners[currentIndex].banner_template_image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "273px",
                      }}
                    >
                      <div className="contact-container">
                        {profile.includePhone &&
                          allBanners[currentIndex].phone_allowed != 0 &&
                          profile.phone && (
                            <div className="contact-item phone">
                              <FaPhoneAlt />
                            </div>
                          )}
                        {profile.includeEmail &&
                          allBanners[currentIndex].email_allowed != 0 && (
                            <div className="contact-item email">
                              <MdEmail /> {profile.email}
                            </div>
                          )}
                        {profile.includeWebsite &&
                          allBanners[currentIndex].website_allowed != 0 && (
                            <div className="contact-item email">
                              <FaGlobe />{" "}
                              {profile.company_website
                                ? formatWebsite(profile.company_website)
                                : ""}
                            </div>
                          )}
                      </div>
                      <div className="quotes-positions">
                        {profile.quotes &&
                          allBanners[currentIndex].default_quotes &&
                          profile.quotes
                            .split(",")
                            .map((quotes, index) => (
                              <li key={index}>{quotes.trim()}</li>
                            ))}
                      </div>
                      <div className="job-positions" ref={jobsContainerRef}>
                        <ul>
                          {profile.jobs &&
                            allBanners[currentIndex].job_allowed != 0 &&
                            profile.jobs
                              .split(",")
                              .map((job, index) => job.trim()) // Trim spaces
                              .filter((job) => job.length > 0) // Filter out blank jobs
                              .map((job, index) => (
                                <li key={index}>{job.trim()}</li>
                              ))}
                        </ul>
                      </div>
                      {(allBanners[currentIndex].phone_allowed != 0 ||
                        allBanners[currentIndex].email_allowed != 0 ||
                        allBanners[currentIndex].website_allowed != 0) && (
                          <div className="send-button">send your cv</div>
                        )}

                      <div className={`slider-controls`} ref={componentPreRef}>
                        <button
                          onClick={handlePrevious}
                          className="prev-btn"
                          ref={prevButtonRef}
                          style={{ zIndex: 1 }}
                        >
                          <IoIosArrowBack />
                        </button>
                        <button
                          onClick={handleNext}
                          className="next-btn"
                          ref={nextButtonRef}
                          style={{ zIndex: 1 }}
                        >
                          <IoIosArrowForward />
                        </button>
                      </div>

                      <div className="powerby-img d-flex justify-content-center align-items-center">
                        <img
                          src="/job/naukrify_poweredby.png"
                          alt="User profile picture"
                          className=" img-fluid"
                        />
                      </div>
                      <div className="profile-img bg-white rounded-circle d-flex justify-content-center align-items-center">
                        <img
                          style={{ zIndex: 1 }}
                          src={profile.photo}
                          alt="User profile picture"
                          className="rounded-circle img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </BannerScaleWrapper>
              </div>
            </div>
          )}

          <Row className=" mt-4">
            <Col md={8}>
              <h4 className="name mt-3 text-uppercase">
                {profile.name && capitalize(profile.name)}
              </h4>
              <div className="about">
                <p className="">
                  {(profile.role || profile.company_name) && (
                    <>
                      {profile.role ? capitalize(profile.role) : ""} At{" "}
                      {capitalize(profile.company_name) || ""}
                    </>
                  )}
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="company mt-3">
                {profile.company_name && (
                  <div className="d-flex align-items-center ">
                    {profile.company_logo ? (
                      <img
                        src={profile.company_logo}
                        alt="Company Logo"
                        className="img-fluid me-2"
                        style={{ width: "25px", objectFit: "contain" }}
                      />
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center bg-secondary text-white me-2"
                        style={{
                          width: "25px",
                          height: "25px",
                          fontSize: "16px",
                        }}
                      >
                        <TbBuilding />
                      </div>
                    )}
                    <span className="me-2" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{capitalize(profile.company_name)}</span>
                  </div>
                )}

                {!profile.company_name && (
                  <div
                    className="d-flex justify-content-center align-items-center bg-white text-black me-2"
                    style={{
                      width: "100%",
                      height: "30px",
                      fontSize: "14px",
                      filter: "blur(3px)",
                    }}
                  >
                    Company Name
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <FormGroup>
                {allBanners[currentIndex].phone_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includePhone"
                      name="includePhone"
                      checked={profile.includePhone}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includePhone">Add Phone</Label>
                  </>
                )}
                {allBanners[currentIndex].email_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeEmail"
                      name="includeEmail"
                      checked={profile.includeEmail}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeEmail">Add Email</Label>
                  </>
                )}
                {allBanners[currentIndex].website_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeWebsite"
                      name="includeWebsite"
                      checked={profile.includeWebsite}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeWebsite">Add Website</Label>
                  </>
                )}
              </FormGroup>
            </Col>
            {allBanners[currentIndex].default_quotes && (
              <Col md={6}>
                <FormGroup>
                  <Label for="quotes">Quotes</Label>
                  <Input
                    className="form-control form-control-sm"
                    type="text"
                    id="quotes"
                    name="quotes"
                    value={profile.quotes}
                    onChange={handleChange}
                    placeholder="Enter quotes"
                  />
                </FormGroup>
              </Col>
            )}
            {allBanners[currentIndex].job_allowed != 0 && (
              <Col md={6}>
                <FormGroup>
                  <Label for="jobs">Jobs</Label>
                  <Input
                    className="form-control form-control-sm"
                    type="text"
                    id="jobs"
                    name="jobs"
                    value={profile.jobs}
                    onChange={handleChange}
                    placeholder="Enter job title"
                  />
                  <small className="form-text" style={{ color: "red" }}>
                    Enter job titles separated by commas. Example: (Php
                    Developer, Python Developer)
                  </small>

                  {errors.jobs && (
                    <div className="text-danger mt-2">{errors.jobs}</div>
                  )}
                </FormGroup>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          {isBannerUnlocked == true && (
            <Button
              type="button"
              color="secondary"
              disabled={isDownloading} // Disable the button when downloading
              onClick={handleDownloadClick}
            >
              {isDownloading ? "Downloading..." : "Download"}
            </Button>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default BannerModal;
